import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        display: 'inline-block',
        padding: '2px 6px',
        borderRadius: 4,
        fontSize: 10,
        fontWeight: 600,
        lineHeight: 1.4,
      },
      uppercase: {
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
      },
      default: {
        background: theme.palette.darkGrey.bg,
        color: theme.palette.darkGrey.color,
      },
      primary: {
        background: theme.palette.deepBlue.bg,
        color: theme.palette.primary.main,
      },
      success: {
        background: theme.palette.green.bg,
        color: theme.palette.green.color,
      },
      warning: {
        background: theme.palette.orange.bg,
        color: theme.palette.orange.color,
      },
      danger: {
        background: theme.palette.red.bg,
        color: theme.palette.red.color,
      },
    }),
  { name: 'Tag' }
);

export const Tag = React.forwardRef(function Tag(
  { color = 'default', uppercase = false, className, children, ...rest },
  ref
) {
  const classes = useStyles();
  return (
    <span
      {...rest}
      ref={ref}
      className={clsx(
        classes.root,
        classes[color] || classes.default,
        uppercase && classes.uppercase,
        className
      )}
    >
      {children}
    </span>
  );
});
